import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface Pagination {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
  from: number;
  to: number;
}

@Component({
  selector: 'app-crm-pagination',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './crm-pagination.component.html',
  styleUrl: './crm-pagination.component.scss'
})
export class CrmPaginationComponent {
  @Input() pagination: Pagination = {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    from: 1,
    to: 10
  };

  @Output() pageChanged = new EventEmitter<number>();
  @Output() perPageChanged = new EventEmitter<number>();

  get pages(): (number | string)[] {
    const total = this.pagination.last_page;
    const current = this.pagination.current_page;
    const range: (number | string)[] = [];

    if (total <= 7) {
      // If total pages are less than or equal to 7, show all pages
      for (let i = 1; i <= total; i++) {
        range.push(i);
      }
    } else {
      // Always include the first 5 pages if current is near the start
      if (current <= 4) {
        for (let i = 1; i <= 5; i++) {
          range.push(i);
        }
        range.push('...');
        range.push(total);
      }
      // Show the last 5 pages if current is near the end
      else if (current >= total - 3) {
        range.push(1);
        range.push('...');
        for (let i = total - 4; i <= total; i++) {
          range.push(i);
        }
      }
      // Display first page, range around current, and last page with ellipses
      else {
        range.push(1);
        range.push('...');
        range.push(current - 1, current, current + 1);
        range.push('...');
        range.push(total);
      }
    }

    return range;
  }

  onSelectPage(page: number | string): void {
    if (typeof page === 'number' && page >= 1 && page <= this.pagination.last_page) {
      this.pageChanged.emit(page);
    }
  }

  onPerPageChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.perPageChanged.emit(Number(selectedValue));
  }
}
